import extraSpicyImg from '../img/icons/dietary/Extra-Spicy.svg';
import glutenFreeImg from '../img/icons/dietary/Gluten-Free.svg';
import spicyImg from '../img/icons/dietary/Spicy.svg';
import veganImg from '../img/icons/dietary/Vegan.svg';
import vegetarianImg from '../img/icons/dietary/Vegetarian.svg';
import GlutenFreeSVG from '../components/dietary/GlutenFreeSVG';
import VeganSVG from '../components/dietary/VeganSVG';
import VegetarianSVG from '../components/dietary/VegetarianSVG';
import ExtraSpicySVG from '../components/dietary/ExtraSpicySVG';
import SpicySVG from '../components/dietary/SpicySVG';

export const imageLookup = {
  ['Extra-Spicy'] : extraSpicyImg,
  ['Gluten-Free'] : glutenFreeImg,
  ['Spicy'] : spicyImg,
  ['Vegan'] : veganImg,
  ['Vegetarian'] : vegetarianImg,
};

export const imageLookupForPromotion = (imageType, color, iconSize) => {

    switch (imageType) {
        case 'Extra-Spicy':
            return <ExtraSpicySVG color={color} iconSize={iconSize} />;

        case 'Gluten-Free':
            return <GlutenFreeSVG color={color} iconSize={iconSize} />;

        case 'Spicy':
            return <SpicySVG color={color} iconSize={iconSize}/>;

        case 'Vegan':
            return <VeganSVG color={color} iconSize={iconSize} />;

        case 'Vegetarian':
            return <VegetarianSVG color={color} iconSize={iconSize} />;

        default:
            return null;
    }

};

const DietaryIcons = ({ icons, style = '', iconSize = 24, isPromotion = false, iconColor=''}) => {
  return icons?.length ?
    <div className="dietary-icons" style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: '4px', ...(style && style) }}>
    {
        
        icons.map((option, idx) => {
            if (isPromotion) {
                return (
                    <div
                        key={option + idx}
                        role="img"
                        alt={option}
                        style={{ height: iconSize }}
                        data-testid={`dietary-icon-${option}`}
                    >
                        {imageLookupForPromotion(option, iconColor, iconSize)}
                    </div>
                )
                      
            }
            else {
                const icon = imageLookup[option];
                if (!icon) return <></>;
                return (
                    <img
                        key={option + idx}
                        role="img"
                        alt={option}
                        style={{ height: iconSize }}
                        data-testid={`dietary-icon-${option}`}
                        src={icon}
                    />
                );
            }
        }
        )
    }
    </div>
    :
    null;
};
export default DietaryIcons;